import conf from 'client/conf';

export const CONSENT_GET_SUCCESS = 'CONSENT_GET_SUCCESS';
export const CONSENT_GET_FAILURE = 'CONSENT_GET_FAILURE';
export const SUBSCRIPTION_SUCCESS = 'SUBSCRIPTION_SUCCESS';
export const SUBSCRIPTION_FAILURE = 'SUBSCRIPTION_FAILURE';

const preRegBaseUrl = `${conf.STRIDE_PRE_REGISTRATION_BASE_URL}/api/v1/public`;

type SubscribeDataBase = {
  consentIds: string[];
  signupSource: string;
  utmCampaign?: string;
  utmContent?: string;
  utmMedium?: string;
  utmSource?: string;
  utmTerm?: string;
};

export type SubscribeData =
  | (SubscribeDataBase & { email: string; phone?: string })
  | (SubscribeDataBase & { phone: string; email?: string });

export const getConsent =
  (consentId: string) =>
    async (dispatch, getState, { apiClient }) => {
      try {
        const { data } = await apiClient.get(`${preRegBaseUrl}/consent?consentId=${consentId}`);
        dispatch({ type: CONSENT_GET_SUCCESS, payload: data });
      } catch (e) {
        dispatch({
          type: CONSENT_GET_FAILURE,
          payload: { consentId },
        });
      }
    };

export const subscribe =
  (subscribeData: SubscribeData) =>
    async (dispatch, getState, { apiClient }) => {
      try {
        const { brand } = getState();
        await apiClient.put(
          `${preRegBaseUrl}/profile`,
          { ...subscribeData, agencyCode: brand },
          {
            headers: { 'Content-Type': 'application/json' },
          },
        );
        dispatch({ type: SUBSCRIPTION_SUCCESS });
      } catch (e) {
        dispatch({
          type: SUBSCRIPTION_FAILURE,
        });
      }
    };

export const getUtmParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams: Record<string, string | null> = {
    utmSource: urlParams.get('utm_source'),
    utmMedium: urlParams.get('utm_medium'),
    utmCampaign: urlParams.get('utm_campaign'),
    utmTerm: urlParams.get('utm_term'),
    utmContent: urlParams.get('utm_content'),
  };

  Object.keys(utmParams).forEach((key) => {
    if (!utmParams[key]) {
      delete utmParams[key];
    }
  });

  return utmParams;
};
